// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"532":"styles","6740":"print"}[chunkId] + "-" + {"532":"796313bfe2c8ee125045","6740":"b7b18a85be0f5b4ff42e"}[chunkId] + ".css";
};